import {useEffect, useState} from "react";

import dashboard_api from "../api/protected/dashboard"

const VerifyEmailPopup= (props) => {
    const wide = props.wide && props.wide
    const [popUpPage, setPopUpPage] = useState(false)

    useEffect(() => {
        dashboard_api.getValidateEmail().then((response) => {
            const isAlreadyVerified = response.data === 1;

            if (!isAlreadyVerified) {
                setPopUpPage(true)
            } else {
                setPopUpPage(false)
            }
        })
    }, []);


    return (
        <>
            <div className="page-mask"/>
            <div className={wide && wide ? "dialog-container wide" : "dialog-container"}>
                <div className="dialog-header-container">
                    <div className="dialog-header">Email Verification</div>
                    <div className="dialog-text">Please click the link in your email to verify your email address and get access to the platform. </div>

                </div>
            </div>
        </>
    )
}

export default VerifyEmailPopup
